<template>
  <div id="spot">
    <div class="kg_top_category_inner_static">
      <div class="wrap_lst_spot">
        <!-- Swiper -->
        <swiper :options="swiperOptions" v-if="horizontalMode === false && swipeList.length > 0" ref="kagullSwiper">
          <swiper-slide class="kg_top_category_panel" v-for="(obj, index) in swipeList" :key="'swipe' + index">
            <div class="lst_spot">
              <div class="image"><img :src="getImg(obj.img)" @error="noImage"></div>
              <h2 class="tit">
                <span class="ins_wrap">
                  <strong class="en">{{obj.name}}</strong>
                  <span class="jp">{{obj.caption}}</span>
                </span>
              </h2>
            </div>
          </swiper-slide>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </swiper>
        <div class="btn_wrap">
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import * as App from '../../../utils/App'

export default {
  name: 'addNewUserModal',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    swipeList: Array,
    swiperOptions: Object,
    horizontalMode: {
      type: Boolean,
      default: false
    },
    horizontalViewCnt: {
      type: Number,
      default: 10
    }
  },
  methods: {
    setSlideTo: function (index) {
      if (this.$refs.kagullSwiper.swiper) {
        this.$refs.kagullSwiper.swiper.slideToLoop(index)
      }
    },
    getImg: function (img) {
      return App.getKagullResource(img)
    },
    noImage: function (element) {
      element.target.src = App.getKagullResource('noimage.svg')
    }
  },
  computed: {
    swiperActiveIndex: function () {
      if (this.$refs.kagullSwiper.swiper) {
        return this.$refs.kagullSwiper.swiper.activeIndex
      }
      return this.swiperOptions.initialSlide
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/top/CategoryList.vue